<script lang="ts">
export default { name: 'MainSectionPromotions' };
</script>

<script setup lang="ts">
import { computed } from 'vue';

import { Promotion } from '@interfaces';
import { useStore } from '@store';

import SectionPromotions from '@components/Sections/SectionPromotions.vue';

const store = useStore();

const promotions = computed(() => {
  return store.state.promotions.items.map((promo: Promotion) => ({
    id: promo.id,
    title: promo.title,
    body: promo.body,
    url: promo.url ?? null,
    image: promo.image ?? null,
    youtubeVideoId: promo.youtubeVideoId ?? null,
    callToAction: promo.callToAction ?? null,
    textAlign: promo.textAlign ?? null,
    startDate: promo.startDate ?? null,
    endDate: promo.endDate ?? null,
  }));
});
</script>

<template>
  <section v-if="promotions.length" id="section-promotions">
    <SectionPromotions v-bind="{ promotions }" />
  </section>
</template>

<style scoped lang="scss">
#section-promotions {
  margin-top: 0;
  padding-top: 50px;
  z-index: 1;
}
</style>
